export enum ErrorType {
  RenteAanbod = 'renteAanbod'
}
